var _foreignObject, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45 45h260v260H45z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 73h204v204H73z",
    style: {
      fill: "#d7542b"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 189.958c38.484-32.053 71.96-55.719 96.667-72.069 21.886-14.484 33.335-20.874 48.806-24.738C256.072 83.76 290.152 96.098 309 105c-4.367 21.505-15.712 69.731-40.222 109.111-9.602 15.427-18.475 25.079-29.333 32.667-16.107 11.256-31.75 14.593-39.778 16.222-21.337 4.33-37.923 1.671-56.889-1.556-17.299-2.943-41.757-8.773-69.778-21.333z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.25,
    cy: 172,
    rx: 83.123,
    ry: 82,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.25 172 32.806 63.556a71.6 71.6 0 0 0 20.222-14.833c9.615-10.095 14.059-20.713 16.111-26.889z",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.806,
    cy: 189.958,
    r: 7,
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.194,
    cy: 228.556,
    r: 7,
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.028,
    cy: 127.528,
    r: 7,
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25 87c-47.485 0-86.116 38.131-86.116 85s38.632 85 86.116 85 86.116-38.131 86.116-85-38.631-85-86.116-85m0 3.5c45.273 0 82.021 35.929 82.59 80.458h-20.322c-.568-33.43-28.273-60.458-62.268-60.458-34.012 0-61.728 27.054-62.269 60.507l-3.648.016v-.001H93.659c.533-44.558 37.295-80.522 82.591-80.522m0 118c-19.568 0-35.577-14.987-36.901-33.959h5.238a1.75 1.75 0 0 0 1.237-2.987s-.435-.435-1.237-.513c-.384-.037-2.252-.062-5.31-.074.556-19.679 16.89-35.467 36.974-35.467 20.435 0 37 16.342 37 36.5s-16.566 36.5-37.001 36.5m-1.75-76.456c-21.173.894-38.176 17.916-38.723 38.915-4.655-.005-10.923.007-18.295.035.537-30.99 25.699-56.044 57.019-56.95zm-38.66 42.497c1.296 20.305 17.994 36.544 38.66 37.417v18c-30.802-.891-55.655-25.137-56.979-55.416h18.319zM178 211.956c20.666-.873 37.363-17.11 38.66-37.415h18.32c-1.325 30.28-26.177 54.525-56.979 55.415zm38.724-40.998c-.548-20.998-17.552-38.019-38.724-38.914v-18c31.308.905 56.463 25.941 57.018 56.914zm-123.025 3.583h20.322c1.332 32.162 27.796 58.019 60.479 58.916v20c-43.957-.904-79.455-35.658-80.801-78.916M178 253.456v-20c32.684-.897 59.147-26.753 60.479-58.915h20.322c-1.346 43.258-36.844 78.011-80.801 78.915",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25 154.5c-9.755 0-17.692 7.85-17.692 17.5s7.937 17.5 17.692 17.5 17.692-7.85 17.692-17.5-7.937-17.5-17.692-17.5m0 31.5c-7.838 0-14.192-6.268-14.192-14s6.354-14 14.192-14 14.192 6.268 14.192 14-6.354 14-14.192 14",
    style: {
      fill: "#0c0c0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.667 98.333c-13.09 7.047-22.749 14.127-38.222 25.556-30.606 22.604-54.186 43.603-70.445 59.069V73h204c-44.998 2.194-76.336 15.105-95.333 25.333",
    style: {
      fill: "#d7542b"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277 73v14.26a137.8 137.8 0 0 0-31.111-2.149c-3.34.15-12.688.693-24.556 3.333-3.782.841-12.965 3.041-24.333 7.667-5.252 2.137-14.531 6.241-29.083 15.472-13.341 8.463-22.77 16.09-41.083 31-9.954 8.104-11.297 9.485-31.278 26.083A4857 4857 0 0 1 73 187.291v-14.208c30.768-25.944 54.073-45.205 63.136-52.427 5.975-4.761 12.198-9.419 13.052-10.057 4.989-3.73 8.162-6.093 12.771-9.141 5.065-3.349 9.289-5.821 11.667-7.208a276 276 0 0 1 8.466-4.74c8.998-5.086 17.004-8.203 22.964-10.149a130 130 0 0 1 11.778-3.222A134.4 134.4 0 0 1 240.084 73z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.25 93.5c-5.736-1.995-17.257-5.95-30.917-8.111-8.478-1.342-26.633-4.045-48.667.778-16.908 3.701-28.423 10.152-39.556 16.389-11.582 6.489-21.411 14.182-41.069 29.569-2.475 1.937-12.911 10.126-28.853 23.502A1475 1475 0 0 0 73 187v14c4.827-4.429 65.933-60.265 106.806-86.574 9.376-6.035 21.136-12.736 36.972-16.871 16.579-4.329 30.152-3.894 34.908-3.632 11.539.635 20.32 2.96 28.315 5.077a184 184 0 0 1 23.833 8.083c-6.032 28.708-14.007 51.745-20.722 68.361 0 0-13.323 32.965-31.15 53.696-5.407 6.288-11.42 11.109-11.42 11.109-1.403 1.125-6.136 4.846-13.042 8.583-14.203 7.688-28.013 10.263-31.667 10.917-30.516 5.459-62.154-4.425-90.833-13.667a423 423 0 0 1-32-11.75v11.222a575 575 0 0 0 25.556 9.278c25.806 8.685 39.918 13.435 59 15.556 7.674.853 27.576 2.918 48.222-2 4.635-1.104 14.865-3.615 26.556-10.056a102 102 0 0 0 9.26-5.78c2.917-2.043 10.551-7.615 18.962-17.109 6.588-7.436 11.186-14.493 15.778-22.444 12.353-21.394 19.485-40.303 21.778-46.556 5.883-16.044 12.755-38.329 17.444-66.028A205 205 0 0 0 298.25 93.5",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.8ce605691293bb0db8ad48c54ff97386.svg";
export { ForwardRef as ReactComponent };